(function() {
	const delegate = new domDelegate.Delegate(document.body);

	// Track clicks on interactive elements
	const selector = [
		'[data-action]',
		'[aria-haspopup]',
		'nav a',
		'.SectionHeader__Links a',
		'.Slideshow__Slide',
	].join(', ');
	delegate.on('click', selector, function(event) {
		var target = event.target;
		if (!target.matches(selector)) {
			target = target.closest(selector);
		}
		
		var action, label = null;

		if (target.dataset.action) {
			action = target.dataset.action;
			switch (action) {
				case 'add-to-cart':
					return;
				case 'toggle-collapsible':
				case 'toggle-tab':
					label = target.textContent;
					break;
				case 'select-value':
					label = target.dataset.value;
					var popover = target.closest('.Popover');
					if (popover) label = `${popover.id}: ${label}`;
					break;
				case 'open-drawer':
				case 'close-drawer':
					label = target.dataset.drawerId;
					break;
				case 'open-modal':
				case 'close-modal':
					label = target.getAttribute('aria-controls');
					break;
			}
		} else if (target.ariaHasPopup) {
			action = target.ariaExpanded ? 'open-popover' : 'close-popover';
			label = target.getAttribute('aria-controls');
		} else if (target.matches('nav a')) {
			action = 'nav';
			label = target.childNodes[0].textContent;
			var parent = target.closest('.Collapsible__Inner');
			if (parent) {
				parent = parent.previousElementSibling;
				if (parent.matches('button')) {
					label = `${parent.childNodes[0].textContent} > ${label}`;
				}
			} else {
				var parent = target.closest('.MegaMenu');
				if (parent) {
					parent = parent.previousElementSibling;
					if (parent.matches('a')) {
						label = `${parent.childNodes[0].textContent} > ${label}`;
					}
				}
			}
		} else if (target.matches('.SectionHeader__Links a')) {
			action = 'collection-link';
			label = target.textContent;
		} else if (target.matches('.Slideshow__Slide')) {
			action = target.closest('[data-ga-category]').dataset.gaCategory || 'Slideshow';
			label = `${target.dataset.gaLabel || 'Slide'} (${[...target.parentNode.children].indexOf(target) + 1})`;
		} else {
			return;
		}

		if (gtag) gtag('event', 'click', { event_category: action, event_label: label });
	});

	
	var abval = parseInt(Cookies.get('abval')) % 10;
	if (isNaN(abval)) abval = parseInt(Math.random() * 10);
	document.documentElement.dataset.abval = abval;
	Cookies.set('abval', document.documentElement.dataset.abval, { secure: true, sameSite: 'none' });
	document.addEventListener('trackingLoaded', e => { if (gtag) gtag('event', 'abval_'+abval) });
})();